import { Application } from "@hotwired/stimulus"

const application = Application.start()

// PSA - If you want to see Stimulus logs, set this to true
application.debug = false
window.Stimulus = application

export { application }
